import { ENVIRONMENTS } from '@/constants';
const ENVIRONMENT = import.meta.env.VITE_ENV_TYPE?.toUpperCase() ?? 'DEVELOPMENT';

const Cookies = {
	createCookie: function (name, value, days, options = {}) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = '; expires=' + date.toUTCString();
		}
		let cookie = name + '=' + value + expires + '; path=/';
		if (options != undefined && options.cross_domain == true) {
			const hostname = window.location.hostname;
			if (hostname.indexOf('cobrashowcreator') != -1) {
				//Not localhost
				cookie += `;domain=cobrashowcreator.com`;
			} else if (ENVIRONMENT !== ENVIRONMENTS.PRODUCTION.key && hostname.endsWith('.amplifyapp.com')) {
				// Share the cookie across all branch/PR preview subdomains for this
				// Amplify app, e.g. pr-123.<app-id>.amplifyapp.com and
				// development.<app-id>.amplifyapp.com both need the same login.
				// Gated to non-production builds so this can never fire against prod,
				// even if prod's raw Amplify-issued domain is ever reachable.
				const app_domain = hostname.split('.').slice(-3).join('.');
				cookie += `;domain=.${app_domain}`;
			}
		}
		document.cookie = cookie;
	},
	readCookie: function (name) {
		var nameEQ = name + '=';
		var ca = document.cookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
		}
		return null;
	},
	eraseCookie: function (name) {
		// Clear both the host-only cookie and, where applicable, the
		// cross-domain one - a cookie set with a `domain` attribute can only
		// be cleared by expiring it with that same attribute.
		this.createCookie(name, '', -1);
		this.createCookie(name, '', -1, { cross_domain: true });
	},
};

export default Cookies;
